// import Vue from 'vue'
import axios from 'axios'
import config from '@/config'
// import selfCube from '@/libs/selfCube'
// import {
//   toast,
//   createAPI
// } from 'cube-ui'
// console.log('1111')
// console.log(toast, createAPI)
// console.log(Vue)

// function showToast (txt) {
//   const toast = Vue.$createAPI({
//     time: 1000,
//     txt
//   })
//   toast.show()
// }
// https://www.kancloud.cn/yunye/axios/234845
axios.defaults.baseURL = config.apiBasePath
// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // console.log(config)
    let token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    config.headers.HostName = location.hostname
    return config
  },
  function (error) {
    console.log('request error: ' + error)
    return Promise.resolve({
      code: '-1',
      msg: '请求失败， 请检查网络: ' + error
    })
  })

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    let data = response.data
    if (!data) {
      alert('返回数据异常')
    }
    if (data.code === '-8') {
      const actuuid = localStorage.getItem('actuuid')
      alert('登录超时,请重启登录')
      localStorage.removeItem('token')
      window.location.href = `${config.apiBasePath}callfee/login?actuuid=${actuuid}`
    }
    if (data) {
      return data
    }
    return response
  },
  function (error) {
    console.log('response error: ' + error)
    return Promise.resolve({
      code: '-1',
      msg: '请求失败， 请检查网络'
    })
  })

let request = {}
// vue  插件的写法
request.install = function (Vue, options) {
  Vue.prototype.$get = axios.get
  Vue.prototype.$post = axios.post
}
request.get = axios.get
request.post = axios.post
export default request



// WEBPACK FOOTER //
// ./src/libs/request.js